import React, { useEffect, useState } from "react";
import Layout from "../Componants/Layout";
import { Col, Form, Row } from "react-bootstrap";
import { Container } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getRequest, postRequest } from "../services/apiMethods";
import { getQueryParams } from "../utils/HelperFunctions";

export default function PreRegistration() {
  const deviceType = localStorage.getItem("deviceType") || "";
  const fcm_token = localStorage.getItem("fcm_token") || "";
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = getQueryParams(location.search);
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);
  const { referId } = queryParams;

  useEffect(() => {
    localStorage.setItem("referId", referId ?? "");
  }, [referId]);


  const { data: categoryList, error, isLoading } = useQuery({
    queryKey: ["categories"],
    queryFn: () => getRequest("/auth/services"),
  });

  const userId = localStorage.getItem("userId");

  const { data: userDetails, error: userError, isLoading: userLoading } = useQuery({
    queryKey: ["userDetails", userId],
    queryFn: () => getRequest(`profile/info?id=${userId}`),
    enabled: !!userId,
  });



  const { mutate, isLoading: isSubmitting } = useMutation({
    mutationFn: (data) => {
      const modifyData = {
        ...data,
        id: userId,
        role: "Vendor",
        deviceType,
        deviceToken: fcm_token,
      };
      return postRequest("/auth/register", modifyData);
    },
    onSuccess: (data) => {
      if (!userId) {
        localStorage.setItem("userId", data?.data?.id);
      }
      navigate("/registration-address");
    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
  });


  const handleSelect = (id) => {
    setSelectedCategoryIds(prevIds => {
        if (prevIds.includes(id)) {
            // If the id is already selected, remove it (unselect)
            return prevIds.filter(existingId => existingId !== id);
        } else {
            // If the id is not selected, add it (select)
            return [...prevIds, id];
        }
    });
};

const handleSubmit = () => {
  if (selectedCategoryIds.length > 0) {
  const filteredProducts = categoryList?.data
  .map(product => ({
    ...product,
    services: product.services.filter(service => selectedCategoryIds.includes(service._id))
  }))
  .filter(product => product.services.length > 0); // Exclude products with no matching services

  const transformedData = filteredProducts.map(item => ({
    category: item._id,
    services: item.services.map(service => service._id)
}));

    const payload = { 
      role: "Vendor",
      deviceType,
      deviceToken: fcm_token,
      services: selectedCategoryIds,
      vendorServices:transformedData
    };
      mutate(payload);
  }
}
    useEffect(() => {
        if (userDetails?.data?.services) {
            setSelectedCategoryIds(userDetails?.data?.services)
        }
    }, [userId])
  return (
    <Layout>
      <Container>
        <Row>
         <Col lg={6}>
<div className="pre-registration">
       
        <div className="">

          <h4 className="RegisTitle">Confirm your services</h4>
          <p>Tell us the services you offer to clients.</p>
        </div>

          <Form className="cmn-form-set">
 
            {Array.isArray(categoryList?.data) && (
              <Form.Group className="mb-3">
                <div className="services-suggestions">
                  {categoryList.data.map((val, index) => (
                    <div key={index}>
                      <p style={{ marginBottom: "8px", fontWeight: 600 }}>{val.categoryName}</p>
                      <ul>
                        {val.services?.map((ele, i) => (
                          <li
                            key={i}
                            style={{ cursor: "pointer" }}
                            onClick={() => handleSelect(ele._id)}
                            className={selectedCategoryIds.includes(ele._id) ? "activeSelected" : ""}
                          >
                            + {ele.serviceName}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </Form.Group>
            )}
          </Form>

          <div className="d-flex justify-content-between mt-4 mb-2">
                 
                 <button className={selectedCategoryIds.length === 0 ? 'theme-comm-btn-disabled' : 'theme-comm-btn'} onClick={handleSubmit} disabled={selectedCategoryIds.length === 0}>
                     Next
                 </button>
             </div>
        </div>
    
        </Col>
        </Row>
      </Container>
    </Layout>
  );
}
